
export default {
  // Common
  "language": "Idioma",
  "language_description": "Alterar o idioma usado em toda a aplicação",
  "save_language": "Salvar Preferência de Idioma",
  "updating": "Atualizando...",
  "return_home": "Voltar para Início",
  "sign_out": "Sair",
  "error": "Erro",
  "loading": "Carregando...",
  "cancel": "Cancelar",
  "save": "Salvar",
  "edit": "Editar",
  "delete": "Excluir",
  "back": "Voltar",
  "view_details": "Ver Detalhes",
  "not_applicable": "N/A",
  "invalid_date": "Data inválida",
  "name": "Nome",
  "qty": "Qtd",
  "actions": "Ações",
  "sort_by": "Ordenar por",
  "filter_by": "Filtrar por",
  "ascending": "Crescente",
  "descending": "Decrescente",
  "date_added": "Data de Adição",
  "retry": "Tentar novamente",
  "with": "com",
  "or": "ou",
  "format": "Formato",
  "username": "Nome de usuário",
  "phone_number": "Número de telefone",
  "email": "E-mail",
  "change": "Alterar",
  "save_changes": "Salvar alterações",
};
